<div class="form-builder-container p-4">
  <div class="builder-header">
    <h3>Component Builder</h3>
    <p class="text-muted">
      Resolve a Module / SubModule / InnerModule path from the Configuration
      API, choose what kind of component it drives, and build the JSON that
      describes it.
    </p>
  </div>

  <!-- Step 1: Module -->
  <div class="step-section mb-3" [class.step-active]="!hierarchyResolved">
  <div class="row g-3">
  <div class="col-12 col-md-4">
    <div class="step-label">Step 1 · Module</div>

    <div *ngIf="hierarchyError" class="preview-error mb-2">
      {{ hierarchyError }}
    </div>

    <select
      class="form-select"
      [(ngModel)]="selectedModuleId"
      (ngModelChange)="onModuleChange()"
      [disabled]="loadingHierarchy && modules.length === 0"
    >
      <option value="" disabled>
        {{ loadingHierarchy && modules.length === 0 ? 'Loading modules…' : 'Select a module' }}
      </option>
      <option *ngFor="let m of modules" [value]="m._id">{{ m.name }}</option>
    </select>

  </div>
  <div class="col-12 col-md-4" *ngIf="selectedModule?.sub_module === 'Y'">
    <ng-container>
      <div class="step-label">Step 2 · SubModule</div>
      <select
        class="form-select"
        [(ngModel)]="selectedSubModuleId"
        (ngModelChange)="onSubModuleChange()"
        [disabled]="loadingHierarchy && submodules.length === 0"
      >
        <option value="" disabled>
          {{ loadingHierarchy && submodules.length === 0 ? 'Loading submodules…' : 'Select a submodule' }}
        </option>
        <option *ngFor="let s of submodules" [value]="s._id">
          {{ s.name }}
        </option>
      </select>
    </ng-container>
  </div>
  <div class="col-12 col-md-4" *ngIf="selectedSubModule?.sub_module === 'Y'">
    <ng-container>
      <div class="step-label">Step 3 · Inner Module</div>
      <select
        class="form-select"
        [(ngModel)]="selectedInnerModuleId"
        (ngModelChange)="onInnerModuleChange()"
        [disabled]="loadingHierarchy && innermodules.length === 0"
      >
        <option value="" disabled>
          {{ loadingHierarchy && innermodules.length === 0 ? 'Loading inner modules…' : 'Select an inner module' }}
        </option>
        <option *ngFor="let im of innermodules" [value]="im._id">
          {{ im.name }}
        </option>
      </select>
    </ng-container>

  </div>
  <div class="col-12 mt-2" *ngIf="hierarchyResolved">
      <span class="hierarchy-badge">{{ selectedModule?.name }}</span>
      <span
        class="hierarchy-badge"
        *ngIf="selectedSubModule"
        >{{ selectedSubModule.name || '' }}</span
      >
      <span
        class="hierarchy-badge"
        *ngIf="selectedInnerModule"
        >{{ selectedInnerModule.name || '' }}</span
      >
    </div>
  </div>
  </div>

  <!-- Step 4: Component type -->
  <div class="row g-3 setup-row mb-3">
  <div class="col-12 col-md-6">
  <div
    class="step-section h-100 mb-0"
    *ngIf="hierarchyResolved"
    [class.step-active]="!componentType"
  >
    <div class="step-label">Step 4 · Component Type</div>
    <select
      class="form-select"
      [(ngModel)]="componentType"
      (ngModelChange)="onComponentTypeChange()"
    >
      <option value="" disabled>Select a component type</option>
      <!-- <option value="form">Form</option> -->
      <option value="table">Table</option>
      <!-- <option value="modalform">Modal Form</option> -->
    </select>
  </div>

  </div>

  <!-- Step 5: Basis -->
  <div class="col-12 col-md-6" *ngIf="componentType === 'table'">
  <div class="step-section h-100 mb-0" [class.step-active]="!basis">
    <div class="step-label">Step 5 · Data Source</div>
    <select
      class="form-select"
      [(ngModel)]="basis"
      (ngModelChange)="onBasisChange()"
    >
      <option value="" disabled>Select data source</option>
      <option value="api">API based</option>
      <option value="new">New (manual)</option>
    </select>
  </div>
  </div>
  </div>

  <!-- Step 6: Table -->
  <div class="step-section" *ngIf="componentType === 'table' && basis">
    <div class="step-label">Step 6 · Table Configuration</div>


    <div *ngIf="tableConfigLoading" class="text-muted small mb-2">
      Loading saved configuration…
    </div>
    <div
      *ngIf="tableConfigWarning"
      class="alert alert-warning py-2 px-3 small mb-3"
    >
      {{ tableConfigWarning }}
    </div>

    <div class="view-toggle">
      <button
        type="button"
        [class.active]="tableViewMode === 'form'"
        (click)="setTableViewMode('form')"
      >
        Form view
      </button>
      <button
        type="button"
        [class.active]="tableViewMode === 'json'"
        (click)="setTableViewMode('json')"
      >
        JSON view
      </button>
      <button
        type="button"
        [class.active]="tableViewMode === 'convert'"
        (click)="setTableViewMode('convert')"
      >
        Import old header
      </button>
      <button
        type="button"
        [class.active]="tableViewMode === 'oldImport'"
        (click)="setTableViewMode('oldImport')"
      >
        Import old fields
      </button>
    </div>
    <!-- JSON VIEW -->
    <div *ngIf="tableViewMode === 'json'">
      <p class="text-muted small mb-2">
        Editing the full table document — title, export formats, filter, and
        every column under <code>list.columns</code>. Fields left at their
        default value are omitted automatically.
        <code>parent_id</code> auto-fills from the current hierarchy.
      </p>

      <div class="json-editor-wrap">
        <div class="json-editor-toolbar">
          <span>component-config.json</span>
          <span class="badge bg-warning text-dark" *ngIf="isTableJsonDirty"
            >Unapplied changes</span
          >
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="refreshTableJsonFromForm()"
            >
              Refresh from form
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary"
              (click)="applyTableJson()"
            >
              Apply to form
            </button>
          </div>
        </div>
        <textarea
          class="form-control json-textarea"
          rows="22"
          [(ngModel)]="tableJsonText"
          name="tableJson"
        ></textarea>
      </div>

      <div *ngIf="tableJsonError" class="preview-error mt-2">
        {{ tableJsonError }}
      </div>
    </div>
    <div *ngIf="tableViewMode === 'convert'">
      <p class="text-muted small mb-2">
        Paste an old-style <code>header</code> array (or a full response
        containing one) and merge it into this table's columns. Matching
        <code>key</code>s are updated in place — everything else you've already
        configured on that column (Add/Edit, type, mapping, etc.) is left
        untouched. New keys are added as fresh columns.
        <code>filter: true</code> entries get added to the filter bar;
        <code>click: true</code> entries are marked clickable with an empty
        target you'll need to fill in.
      </p>

      <div class="json-editor-wrap">
        <div class="json-editor-toolbar">
          <span>old-header.json</span>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            (click)="convertAndMergeHeaders()"
          >
            Convert &amp; merge
          </button>
        </div>
        <textarea
          class="form-control json-textarea"
          rows="22"
          [(ngModel)]="headerJsonText"
          name="headerJson"
        ></textarea>
      </div>

      <div *ngIf="headerJsonError" class="preview-error mt-2">
        {{ headerJsonError }}
      </div>

      <div
        *ngIf="headerConvertWarnings.length"
        class="alert alert-warning py-2 px-3 small mt-2"
      >
        <div *ngFor="let w of headerConvertWarnings">{{ w }}</div>
      </div>
    </div>
    <div *ngIf="tableViewMode === 'oldImport'">
      <p class="text-muted small mb-2">
        Paste the old <code>fields: {{ '{' }}...{{ '}' }}</code> config (or an object
        containing a <code>fields</code> object) and merge it into this
        table's columns. Keys that already exist in the current structure
        are <strong>left completely untouched</strong> — nothing is
        overwritten or removed. Only keys with no matching id are added as
        new columns.
      </p>
      <div class="json-editor-wrap">
        <div class="json-editor-toolbar">
          <span>old-fields.json</span>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            (click)="convertAndMergeOldFormat()"
          >
            Convert &amp; merge
          </button>
        </div>
        <textarea
          class="form-control json-textarea"
          rows="22"
          [(ngModel)]="oldFormatJsonText"
          name="oldFormatJson"
        ></textarea>
      </div>
      <div *ngIf="oldFormatJsonError" class="preview-error mt-2">
        {{ oldFormatJsonError }}
      </div>
      <div
        *ngIf="oldFormatConvertWarnings.length"
        class="alert alert-warning py-2 px-3 small mt-2"
      >
        <div *ngFor="let w of oldFormatConvertWarnings">{{ w }}</div>
      </div>
    </div>
    <!-- FORM VIEW -->
    <ng-container *ngIf="tableViewMode === 'form'">
      <div *ngIf="rolesError" class="preview-error mb-3">{{ rolesError }}</div>

      <div class="step-label" style="margin-top:0;">Table settings</div>

      <!-- Row 1: Titles + Data URL -->
      <div class="row g-2 mb-2">
        <div class="col-md-3">
          <label class="field-label">Table title <span class="info-tip" [title]="fieldInfo.title">ⓘ</span></label>
          <input type="text" class="form-control" [(ngModel)]="tableMeta.title" name="tblTitle" />
        </div>
        <div class="col-md-3">
          <label class="field-label">List title <span class="info-tip" [title]="fieldInfo.listTitle">ⓘ</span></label>
          <input type="text" class="form-control" [(ngModel)]="tableMeta.listTitle" name="tblListTitle" />
        </div>
        <div class="col-md-3">
          <label class="field-label">Data URL <span class="info-tip" [title]="fieldInfo.dataUrl">ⓘ</span></label>
          <input type="text" class="form-control" [(ngModel)]="tableMeta.dataUrl" placeholder="e.g. /api/site" name="tblDataUrl" />
        </div>
        <div class="col-md-3">
          <label class="field-label">Data URL Payload <span class="info-tip" [title]="fieldInfo.dataPayload">ⓘ</span></label>
          <input type="text" class="form-control" [(ngModel)]="tableMeta.dataPayloadStr" placeholder='e.g. {"status": 1}' name="tblDataPayload" />
        </div>
      </div>

      <!-- Row 2: Enable Add toggle + inline Add URL fields when enabled -->
      <div class="settings-feature-row mb-2">
        <div class="settings-feature-toggle">
          <label class="field-label">Enable Add</label>
          <div class="yn-toggle">
            <button type="button" [class.y-active]="tableMeta.add" (click)="tableMeta.add = true">Y</button>
            <button type="button" [class.n-active]="!tableMeta.add" (click)="tableMeta.add = false">N</button>
          </div>
        </div>
        <ng-container *ngIf="tableMeta.add">
          <div class="settings-feature-fields">
            <div>
              <label class="field-label">Add URL <span class="info-tip" [title]="fieldInfo.addUrl">ⓘ</span></label>
              <input type="text" class="form-control" [(ngModel)]="tableMeta.addUrl" placeholder="leave empty to disable" name="tblAddUrl" />
            </div>
            <div>
              <label class="field-label">Add route URL <span class="info-tip" [title]="fieldInfo.addRouteUrl">ⓘ</span></label>
              <input type="text" class="form-control" [(ngModel)]="tableMeta.add_routeurl" placeholder="leave empty to use Add URL" name="tblAddRouteUrl" />
            </div>
            <div>
              <label class="field-label">Add URL Payload <span class="info-tip" [title]="fieldInfo.addPayload">ⓘ</span></label>
              <input type="text" class="form-control" [(ngModel)]="tableMeta.addPayloadStr" placeholder='e.g. {"type": "create"}' name="tblAddPayload" />
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Row 3: Enable Edit toggle + inline Edit URL fields when enabled -->
      <div class="settings-feature-row mb-3">
        <div class="settings-feature-toggle">
          <label class="field-label">Enable Edit</label>
          <div class="yn-toggle">
            <button type="button" [class.y-active]="tableMeta.edit" (click)="tableMeta.edit = true">Y</button>
            <button type="button" [class.n-active]="!tableMeta.edit" (click)="tableMeta.edit = false">N</button>
          </div>
        </div>
        <ng-container *ngIf="tableMeta.edit">
          <div class="settings-feature-fields">
            <div>
              <label class="field-label">Edit URL <span class="info-tip" [title]="fieldInfo.editUrl">ⓘ</span></label>
              <input type="text" class="form-control" [(ngModel)]="tableMeta.editUrl" placeholder="leave empty to disable" name="tblEditUrl" />
            </div>
            <div>
              <label class="field-label">Edit route URL <span class="info-tip" [title]="fieldInfo.editRouteUrl">ⓘ</span></label>
              <input type="text" class="form-control" [(ngModel)]="tableMeta.edit_routeurl" placeholder="leave empty to use Edit URL" name="tblEditRouteUrl" />
            </div>
            <div>
              <label class="field-label">Edit URL Payload <span class="info-tip" [title]="fieldInfo.editPayload">ⓘ</span></label>
              <input type="text" class="form-control" [(ngModel)]="tableMeta.editPayloadStr" placeholder='e.g. {"type": "update"}' name="tblEditPayload" />
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Row 4: Export / Filter bar / Load Data -->
      <div class="d-flex gap-4 flex-wrap mb-3 align-items-start">
        <div>
          <label class="field-label">Export <span class="info-tip" [title]="fieldInfo.csv + ' ' + fieldInfo.pdf">ⓘ</span></label>
          <div class="download-pills">
            <button type="button" class="download-pill" [class.on]="tableMeta.csv" (click)="tableMeta.csv = !tableMeta.csv">CSV</button>
            <button type="button" class="download-pill" [class.on]="tableMeta.pdf" (click)="tableMeta.pdf = !tableMeta.pdf">PDF</button>
          </div>
        </div>
        <div>
          <label class="field-label">Filter bar <span class="info-tip" [title]="fieldInfo.filterEnabled">ⓘ</span></label>
          <div class="yn-toggle">
            <button type="button" [class.y-active]="tableMeta.filterEnabled" (click)="tableMeta.filterEnabled = true">Y</button>
            <button type="button" [class.n-active]="!tableMeta.filterEnabled" (click)="tableMeta.filterEnabled = false">N</button>
          </div>
        </div>
        <div>
          <label class="field-label">Load Data <span class="info-tip" [title]="fieldInfo.load_after_filter">ⓘ</span></label>
          <div class="yn-toggle">
            <button type="button" [class.opt-active]="!tableMeta.load_after_filter" (click)="tableMeta.load_after_filter = false">By Default</button>
            <button type="button" [class.opt-active]="tableMeta.load_after_filter" (click)="tableMeta.load_after_filter = true">After Filter</button>
          </div>
        </div>
        <div>
          <label class="field-label">Pagination <span class="info-tip" [title]="fieldInfo.pagination">ⓘ</span></label>
          <div class="yn-toggle">
            <button type="button" [class.y-active]="tableMeta.pagination" (click)="tableMeta.pagination = true">Y</button>
            <button type="button" [class.n-active]="!tableMeta.pagination" (click)="tableMeta.pagination = false">N</button>
          </div>
        </div>
        <div>
          <label class="field-label">Row Selection (Checkboxes) <span class="info-tip" [title]="fieldInfo.enableCheckbox">ⓘ</span></label>
          <div class="yn-toggle">
            <button type="button" [class.y-active]="tableMeta.enableCheckbox" (click)="tableMeta.enableCheckbox = true; tableMeta.is_reprint = true">Y</button>
            <button type="button" [class.n-active]="!tableMeta.enableCheckbox" (click)="tableMeta.enableCheckbox = false; tableMeta.is_reprint = false">N</button>
          </div>
        </div>
      </div>

      <!-- Row Selection / Print Action Config Banner -->
      <div class="row g-2 mb-3 p-2 border rounded bg-light" *ngIf="tableMeta.enableCheckbox">
        <div class="col-md-4">
          <label class="field-label">Action Type</label>
          <select class="form-select form-select-sm" [(ngModel)]="tableMeta.tableActionType" name="tblActionType">
            <option value="printReceipt">Print Receipts (Thermal / Print)</option>
            <option value="custom">Custom Action</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="field-label">Action Button Label</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tableMeta.tableActionLabel" placeholder="Print" name="tblActionLabel" />
        </div>
        <div class="col-md-4">
          <label class="field-label">Selection Guide Badge</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tableMeta.tableActionBadge" placeholder="Select receipts to print" name="tblActionBadge" />
        </div>
      </div>
      <div class="mb-4" *ngIf="tableMeta.filterEnabled">
        <!-- Predefined Filter Flags -->
        <div class="field-group-title">Predefined Filter Flags</div>
        <div class="d-flex flex-wrap gap-4 mb-4">
          <div *ngFor="let flag of filterFlagList">
            <label class="field-label">{{ flag }}</label>
            <div class="yn-toggle">
              <button
                type="button"
                [class.y-active]="tableMeta.filterFlags[flag]"
                (click)="tableMeta.filterFlags[flag] = true"
              >
                Y
              </button>
              <button
                type="button"
                [class.n-active]="!tableMeta.filterFlags[flag]"
                (click)="tableMeta.filterFlags[flag] = false"
              >
                N
              </button>
            </div>
          </div>
        </div>

        <!-- Dynamic Filter Config Array -->
        <div class="field-group-title">Dynamic Filter Config (Add Filter)</div>
        <div
          class="row g-2 mb-2 align-items-center"
          *ngFor="let f of tableMeta.filterConfig; let fi = index"
        >
          <div class="col-md-2">
            <input
              class="form-control form-control-sm"
              placeholder="Label"
              [(ngModel)]="f.label"
              name="tfLabel{{fi}}"
            />
          </div>
          <div class="col-md-2">
            <select class="form-select form-select-sm" [(ngModel)]="f.type" name="tfType{{fi}}">
              <option value="text">text</option>
              <option value="select">select</option>
            </select>
          </div>
          <div class="col-md-2">
            <input
              class="form-control form-control-sm"
              placeholder="apiKey"
              [(ngModel)]="f.apiKey"
              name="tfKey{{fi}}"
            />
          </div>
          <div class="col-md-2" *ngIf="f.type === 'select'">
            <input
              class="form-control form-control-sm"
              placeholder="apiUrl (e.g. Dic)"
              [(ngModel)]="f.apiUrl"
              name="tfApiUrl{{fi}}"
            />
          </div>
          <div class="col-md-2" *ngIf="f.type !== 'select'">
            <input
              class="form-control form-control-sm"
              placeholder="Placeholder"
              [(ngModel)]="f.placeholder"
              name="tfPlace{{fi}}"
            />
          </div>
          <div class="col-md-2">
            <input
              class="form-control form-control-sm"
              placeholder="Col Class"
              [(ngModel)]="f.col"
              name="tfCol{{fi}}"
            />
          </div>
          <div class="col-md-2">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger w-100"
              (click)="removeTableFilterConfig(fi)"
            >
              Remove
            </button>
          </div>

          <!-- Static Options or API Settings (labelKey, valueKey, StaticPayload, placeholder) for Select -->
          <div class="col-12" *ngIf="f.type === 'select'">
            <div class="row g-2 ms-2 mt-1 mb-2">
              <ng-container *ngIf="f.apiUrl">
                <div class="col-md-3">
                  <input
                    class="form-control form-control-sm"
                    placeholder="Showing Key (labelKey e.g. name)"
                    [(ngModel)]="f.labelKey"
                    name="tfLabelKey{{fi}}"
                    title="Key from API response to show in dropdown (labelKey)"
                  />
                </div>
                <div class="col-md-3">
                  <input
                    class="form-control form-control-sm"
                    placeholder="Actual Value Key (valueKey e.g. id)"
                    [(ngModel)]="f.valueKey"
                    name="tfValueKey{{fi}}"
                    title="Key from API response to use as value (valueKey)"
                  />
                </div>
                <div class="col-md-3">
                  <input
                    class="form-control form-control-sm"
                    placeholder="Placeholder (e.g. Select CB)"
                    [(ngModel)]="f.placeholder"
                    name="tfPlace{{fi}}"
                    title="Dropdown placeholder"
                  />
                </div>
                <div class="col-md-3">
                  <input
                    class="form-control form-control-sm font-monospace"
                    placeholder='StaticPayload e.g. { "status": 1 }'
                    [(ngModel)]="f.staticPayloadStr"
                    name="tfStaticPayload{{fi}}"
                    title="Static extra query parameters for API call"
                  />
                </div>
              </ng-container>
              <div class="col-12" *ngIf="!f.apiUrl">
                <div class="d-flex gap-2 flex-wrap">
                  <div
                    class="input-group input-group-sm"
                    style="width: 200px"
                    *ngFor="let opt of f.options; let oi = index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Label"
                      [(ngModel)]="opt.label"
                      name="tfOptL{{fi}}_{{oi}}"
                    />
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Value"
                      [(ngModel)]="opt.value"
                      name="tfOptV{{fi}}_{{oi}}"
                    />
                    <button
                      class="btn btn-outline-danger"
                      type="button"
                      (click)="removeTableFilterOption(f, oi)"
                    >
                      ✕
                    </button>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="addTableFilterOption(f)"
                  >
                    + Add Option
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="addTableFilterConfig()"
        >
          + Add filter config
        </button>
      </div>

      <div class="step-label">Columns ({{ tableRows.length }})</div>
      <div class="column-list mb-3" cdkDropList (cdkDropListDropped)="onColumnDrop($event)">
        <div class="column-card" *ngFor="let row of tableRows; let i = index" cdkDrag>
          <div class="column-card-header" (click)="toggleColumnExpanded(row)">
            <div class="column-reorder-controls" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="column-drag-handle"
                cdkDragHandle
                title="Click and drag to reorder column position"
                aria-label="Drag column"
              >
                <svg width="14" height="18" viewBox="0 0 14 18" fill="currentColor">
                  <circle cx="4" cy="3" r="1.5" />
                  <circle cx="10" cy="3" r="1.5" />
                  <circle cx="4" cy="9" r="1.5" />
                  <circle cx="10" cy="9" r="1.5" />
                  <circle cx="4" cy="15" r="1.5" />
                  <circle cx="10" cy="15" r="1.5" />
                </svg>
              </button>
              <div class="column-move-actions">
                <button
                  type="button"
                  class="column-move-btn"
                  [disabled]="i === 0"
                  (click)="moveColumnUp(i, $event)"
                  title="Move Up"
                  aria-label="Move Up"
                >
                  ▲
                </button>
                <button
                  type="button"
                  class="column-move-btn"
                  [disabled]="i === tableRows.length - 1"
                  (click)="moveColumnDown(i, $event)"
                  title="Move Down"
                  aria-label="Move Down"
                >
                  ▼
                </button>
              </div>
            </div>

            <span class="column-drag-index">#{{ i + 1 }}</span>
            <span class="column-chevron" [class.open]="row.expanded">▶</span>
            <span
              class="column-key-chip"
              (click)="copyColumnKey(row.payload.key, $event)"
              [title]="row.payload.key ? 'Click to copy key: ' + row.payload.key : 'No key to copy'"
            >
              <i class="bi bi-clipboard me-1" *ngIf="row.payload.key"></i>
              {{ row.payload.key || '(no key)' }}
            </span>
            <span
              class="column-title-preview"
              >{{ row.payload.title || 'Untitled column' }}</span
            >
            <span class="column-flag-dots">
              <span class="flag-dot on-add" *ngIf="row.payload.add">ADD</span>
              <span class="flag-dot on-edit" *ngIf="row.payload.edit">EDIT</span>
              <span class="flag-dot on-readonly" *ngIf="row.payload.readonly || (row.payload.readonly_add && row.payload.readonly_edit)">RO</span>
              <span class="flag-dot on-readonly" *ngIf="!row.payload.readonly && row.payload.readonly_add && !row.payload.readonly_edit">RO-ADD</span>
              <span class="flag-dot on-readonly" *ngIf="!row.payload.readonly && !row.payload.readonly_add && row.payload.readonly_edit">RO-EDIT</span>
              <span class="flag-dot" *ngIf="row.payload.ignore_value" style="background:#e0f2fe; color:#0369a1; border:1px solid #bae6fd; font-size:10px;">IGNORE_VAL</span>
            </span>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger ms-2"
              (click)="removeTableColumn(i); $event.stopPropagation()"
            >
              Remove
            </button>
          </div>

          <div class="column-card-body" *ngIf="row.expanded">
            <!-- Section 1: General & Header Properties -->
            <div class="column-section-box">
              <div class="column-section-title">
                <span>General &amp; Header Settings</span>
              </div>
              <div class="row g-2">
                <div class="col-md-3">
                  <label class="field-label"
                    >Key
                    <span class="info-tip" [title]="fieldInfo.colKey"
                      >ⓘ</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="row.payload.key"
                    name="colKey{{i}}"
                    placeholder="e.g. meter_type"
                  />
                </div>
                <div class="col-md-3">
                  <label class="field-label"
                    >Title
                    <span class="info-tip" [title]="fieldInfo.colTitle"
                      >ⓘ</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="row.payload.title"
                    name="colTitle{{i}}"
                  />
                </div>
                <div class="col-md-3">
                  <label class="field-label"
                    >Static Value (Row Value)</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="row.payload.value"
                    name="colValue{{i}}"
                    placeholder="e.g. GET or SET"
                  />
                </div>
                <div class="col-md-3">
                  <label class="field-label"
                    >CSS Class
                    <span class="info-tip" [title]="fieldInfo.class"
                      >ⓘ</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="row.payload.class"
                    name="colClass{{i}}"
                    placeholder="e.g. text-end fw-bold"
                  />
                </div>
                <div class="col-md-12">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="field-label mb-0">
                      Formula / Arithmetic Expression
                      <span class="info-tip" [title]="fieldInfo.formula">ⓘ</span>
                    </label>
                    <div class="d-flex align-items-center gap-1">
                      <!-- Option 1: Auto-fill / Insert from existing table keys dropdown -->
                      <div class="dropdown d-inline-block" ngbDropdown>
                        <button
                          type="button"
                          class="btn btn-xs btn-outline-primary py-0 px-2 d-flex align-items-center gap-1"
                          style="font-size: 11px; height: 24px;"
                          ngbDropdownToggle
                        >
                          <i class="bi bi-key-fill"></i> Auto-fill Keys
                        </button>
                        <div class="dropdown-menu dropdown-menu-end shadow-sm" ngbDropdownMenu style="max-height: 220px; overflow-y: auto;">
                          <h6 class="dropdown-header py-1" style="font-size: 11px;">Existing Table Keys</h6>
                          <div *ngIf="getExistingKeysList().length === 0" class="dropdown-item disabled small text-muted">
                            No column keys available
                          </div>
                          <button
                            type="button"
                            class="dropdown-item py-1 small font-monospace d-flex justify-content-between align-items-center"
                            *ngFor="let k of getExistingKeysList()"
                            (click)="insertKeyIntoFormula(row, k)"
                          >
                            <span>{{ k }}</span>
                            <span class="badge bg-light text-muted ms-2" style="font-size: 10px;">Insert</span>
                          </button>
                        </div>
                      </div>

                      <!-- Quick operator helper buttons -->
                      <div class="btn-group btn-group-sm">
                        <button type="button" class="btn btn-xs btn-outline-secondary py-0 px-1" style="font-size: 11px; height: 24px;" (click)="insertKeyIntoFormula(row, '+')" title="Add">+</button>
                        <button type="button" class="btn btn-xs btn-outline-secondary py-0 px-1" style="font-size: 11px; height: 24px;" (click)="insertKeyIntoFormula(row, '-')" title="Subtract">-</button>
                        <button type="button" class="btn btn-xs btn-outline-secondary py-0 px-1" style="font-size: 11px; height: 24px;" (click)="insertKeyIntoFormula(row, '*')" title="Multiply">*</button>
                        <button type="button" class="btn btn-xs btn-outline-secondary py-0 px-1" style="font-size: 11px; height: 24px;" (click)="insertKeyIntoFormula(row, '/')" title="Divide">/</button>
                        <button type="button" class="btn btn-xs btn-outline-secondary py-0 px-1" style="font-size: 11px; height: 24px;" (click)="insertKeyIntoFormula(row, '(')" title="Open bracket">(</button>
                        <button type="button" class="btn btn-xs btn-outline-secondary py-0 px-1" style="font-size: 11px; height: 24px;" (click)="insertKeyIntoFormula(row, ')')" title="Close bracket">)</button>
                      </div>
                    </div>
                  </div>

                  <input
                    type="text"
                    class="form-control font-monospace"
                    [class.is-invalid]="hasFormulaKeyErrors(row.payload.formula)"
                    [class.is-valid]="row.payload.formula && !hasFormulaKeyErrors(row.payload.formula)"
                    [(ngModel)]="row.payload.formula"
                    name="colFormula{{i}}"
                    placeholder="e.g. (balance + coupon_amount) / grid_balance"
                  />

                  <!-- Option 1 Pills: Quick click to insert any existing table key -->
                  <div class="d-flex flex-wrap align-items-center gap-1 mt-1 pt-1" *ngIf="getExistingKeysList().length > 0">
                    <span class="text-muted small me-1" style="font-size: 11px;">Quick Auto-fill:</span>
                    <button
                      type="button"
                      class="badge bg-light text-primary border py-1 px-2 text-decoration-none"
                      style="font-family: monospace; font-size: 11px; cursor: pointer;"
                      *ngFor="let k of getExistingKeysList()"
                      (click)="insertKeyIntoFormula(row, k)"
                      title="Click to auto-fill {{ k }} into formula"
                    >
                      + {{ k }}
                    </button>
                  </div>

                  <!-- Real-time Spell Check & Key Validation Feedback -->
                  <div class="mt-1" *ngIf="row.payload.formula">
                    <div class="text-danger small" *ngIf="getFormulaKeyErrors(row.payload.formula).length > 0">
                      <i class="bi bi-exclamation-triangle-fill"></i>
                      <strong>Spell check error:</strong> Key(s) not found in table:
                      <span class="badge bg-danger text-white ms-1 me-1" *ngFor="let err of getFormulaKeyErrors(row.payload.formula)">
                        {{ err.word }}
                        <span *ngIf="err.suggestion" class="text-warning text-decoration-underline ms-1">(did you mean: {{ err.suggestion }}?)</span>
                      </span>
                    </div>
                    <div class="text-success small" *ngIf="getFormulaKeyErrors(row.payload.formula).length === 0">
                      <i class="bi bi-check-circle-fill"></i> All keys in formula match existing table columns.
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="field-group-title">
                    Title override by login type
                    <span
                      class="info-tip"
                      title="Only turn this on if this column's title needs to differ per login type."
                      >ⓘ</span
                    >
                  </div>
                  <div class="yn-toggle mb-2">
                    <button
                      type="button"
                      [class.y-active]="row.titleOverrideEnabled"
                      (click)="onTitleOverrideToggle(row, true)"
                    >
                      Y
                    </button>
                    <button
                      type="button"
                      [class.n-active]="!row.titleOverrideEnabled"
                      (click)="onTitleOverrideToggle(row, false)"
                    >
                      N
                    </button>
                  </div>

                  <ng-container *ngIf="row.titleOverrideEnabled">
                    <div *ngIf="loadingRoles" class="text-muted small">
                      Loading roles…
                    </div>

                    <div
                      class="title-override-group mb-3 p-2 border rounded"
                      *ngFor="let group of row.titleOverrideGroups; let gi = index"
                    >
                      <div class="d-flex gap-2 align-items-start">
                        <div class="flex-grow-1">
                          <label class="field-label"
                            >Title for these login types</label
                          >
                          <input
                            type="text"
                            class="form-control mb-2"
                            [(ngModel)]="group.title"
                            (ngModelChange)="onGroupTitleChange(row)"
                            placeholder="e.g. Load Grid"
                            name="ovTitle{{i}}_{{gi}}"
                          />

                          <div class="mb-2" *ngIf="!loadingRoles">
                            <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                              <button
                                type="button"
                                class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                                ngbDropdownToggle
                              >
                                <span class="text-truncate">{{ getSelectedRoleLabel(group.roles, 'Select login types...') }}</span>
                                <span class="badge bg-primary role-btn-badge" *ngIf="group.roles.length">{{ group.roles.length }}</span>
                                                      <span class="role-caret">&#9660;</span>
                              </button>
                              <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                                <div class="px-1 pb-2 mb-1 border-bottom">
                                  <input
                                    type="text"
                                    class="form-control form-control-sm mb-2"
                                    placeholder="Search roles..."
                                    [(ngModel)]="roleSearchTerm['ov_' + i + '_' + gi]"
                                    name="ovSearch{{i}}_{{gi}}"
                                    (click)="$event.stopPropagation()"
                                  />
                                  <div class="d-flex justify-content-between">
                                    <button
                                      type="button"
                                      class="btn btn-link btn-sm p-0 text-decoration-none"
                                      (click)="assignAllRemainingToGroup(row, group)"
                                    >
                                      Assign Remaining
                                    </button>
                                    <button
                                      type="button"
                                      class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                                      (click)="group.roles = []; syncTitleOverridesFromGroups(row)"
                                    >
                                      Clear
                                    </button>
                                  </div>
                                </div>
                                <div style="max-height: 180px; overflow-y: auto;">
                                  <div *ngIf="getFilteredRoles(roleSearchTerm['ov_' + i + '_' + gi]).length === 0" class="text-muted small p-2 text-center">
                                    No roles found
                                  </div>
                                  <div
                                    class="dropdown-item-check"
                                    *ngFor="let r of getFilteredRoles(roleSearchTerm['ov_' + i + '_' + gi])"
                                    (click)="toggleRoleInGroup(row, group, r.type); $event.stopPropagation()"
                                  >
                                    <input
                                      class="form-check-input pointer-events-none"
                                      type="checkbox"
                                      [checked]="isRoleInGroup(group, r.type)"
                                      tabindex="-1"
                                    />
                                    <span class="dropdown-item-label small">
                                      {{ r.name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Selected Role Chips -->
                            <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="group.roles.length">
                              <span
                                class="badge d-flex align-items-center gap-1 px-2 py-1"
                                *ngFor="let roleType of group.roles"
                              >
                                {{ getRoleNameByType(roleType) }}
                                <button
                                  type="button"
                                  class="btn-close btn-close-xs"
                                  aria-label="Remove"
                                  (click)="toggleRoleInGroup(row, group, roleType)"
                                ></button>
                              </span>
                            </div>
                          </div>

                          <button
                            type="button"
                            class="btn btn-sm btn-link px-0"
                            *ngIf="unassignedRoles(row).length"
                            (click)="assignAllRemainingToGroup(row, group)"
                          >
                            + Assign remaining login types ({{ unassignedRoles(row).length
                            }}) to this title
                          </button>
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          (click)="removeTitleOverrideGroup(row, gi)"
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      (click)="addTitleOverrideGroup(row)"
                    >
                      + Add another title group
                    </button>

                    <div
                      class="text-muted small mt-2"
                      *ngIf="unassignedRoles(row).length"
                    >
                      Login types not listed above will keep using the base Title
                      above (“{{ row.payload.title || 'Untitled column' }}”).
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Section 2: Behavior & Visibility Flags -->
            <div class="column-section-box">
              <div class="column-section-title">
                <span>Behavior &amp; Visibility Flags</span>
              </div>
              <div class="behavior-flags-grid">
                <div class="flag-item" *ngFor="let flag of columnBoolFlags">
                  <label class="field-label text-capitalize"
                    >{{ formatFlagLabel(flag) }}
                    <span class="info-tip" [title]="fieldInfo[flag]"
                      >ⓘ</span
                    ></label
                  >
                  <div class="yn-toggle">
                    <button
                      type="button"
                      [class.y-active]="getBoolFlag(row, flag)"
                      (click)="setBoolFlag(row, flag, true)"
                    >
                      Y
                    </button>
                    <button
                      type="button"
                      [class.n-active]="!getBoolFlag(row, flag)"
                      (click)="setBoolFlag(row, flag, false)"
                    >
                      N
                    </button>
                  </div>
                </div>
                <div class="flag-item">
                  <label class="field-label">Status (Active)</label>
                  <div class="yn-toggle">
                    <button
                      type="button"
                      [class.y-active]="row.payload.status === 'Y'"
                      (click)="row.payload.status = 'Y'"
                    >
                      Y
                    </button>
                    <button
                      type="button"
                      [class.n-active]="row.payload.status === 'N'"
                      (click)="row.payload.status = 'N'"
                    >
                      N
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 3: Add / Edit Form Field Settings -->
            <div class="column-section-box" *ngIf="row.payload.add || row.payload.edit">
              <div class="column-section-title">
                <span>Add / Edit Form Field Config</span>
              </div>
              <div class="row g-2">
                <div class="col-md-3">
                  <label class="field-label"
                    >Field type
                    <span class="info-tip" [title]="fieldInfo.colType"
                      >ⓘ</span
                    ></label
                  >
                  <select
                    class="form-select"
                    [(ngModel)]="row.payload.type"
                    (ngModelChange)="onColumnTypeChange(row)"
                    name="colType{{i}}"
                  >
                    <option *ngFor="let t of columnTypes" [value]="t.value">
                      {{ t.label }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="field-label"
                    >Order By (Form Order)
                    <span class="info-tip" [title]="fieldInfo.Order_By"
                      >ⓘ</span
                    ></label
                  >
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="row.payload.Order_By"
                    placeholder="e.g. 1, 2, 3..."
                    name="colOrderBy{{i}}"
                  />
                </div>
                <div class="col-md-3">
                  <label class="field-label"
                    >Regex
                    <span class="info-tip" [title]="fieldInfo.regex"
                      >ⓘ</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="row.payload.regex"
                    name="colRegex{{i}}"
                  />
                </div>
                <div class="col-md-3">
                  <label class="field-label"
                    >Regex message
                    <span class="info-tip" [title]="fieldInfo.regexMessage"
                      >ⓘ</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="row.payload.regexMessage"
                    name="colRegexMsg{{i}}"
                  />
                </div>
              </div>

              <ng-container *ngIf="row.payload.type === 'date'">
                <div class="row g-2 mt-2 p-2 border rounded bg-light">
                  <div class="col-12 text-muted fw-semibold small d-flex align-items-center justify-content-between">
                    <span><i class="bi bi-calendar-date"></i> Date Picker Range & Limit Settings</span>
                    <span class="badge bg-secondary">Min / Max Constraints</span>
                  </div>

                  <div class="col-md-5">
                    <label class="field-label">
                      Min Date
                      <span class="info-tip" [title]="fieldInfo.minDate">ⓘ</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="e.g. today or 2026-01-01"
                        [(ngModel)]="row.payload.minDate"
                        name="colMinDate{{i}}"
                      />
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        [class.active]="row.payload.minDate?.toLowerCase() === 'today'"
                        (click)="row.payload.minDate = row.payload.minDate?.toLowerCase() === 'today' ? '' : 'today'"
                        title="Toggle 'today'"
                      >
                        Today
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        *ngIf="row.payload.minDate"
                        (click)="row.payload.minDate = ''"
                        title="Clear min date"
                      >
                        ✕
                      </button>
                    </div>
                    <small class="text-muted" style="font-size: 11px;">
                      Set as <code>today</code> or specific date <code>YYYY-MM-DD</code> (leave blank for no min limit)
                    </small>
                  </div>

                  <div class="col-md-5">
                    <label class="field-label">
                      Max Date
                      <span class="info-tip" [title]="fieldInfo.maxDate">ⓘ</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="e.g. today or 2026-12-31"
                        [(ngModel)]="row.payload.maxDate"
                        name="colMaxDate{{i}}"
                      />
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        [class.active]="row.payload.maxDate?.toLowerCase() === 'today'"
                        (click)="row.payload.maxDate = row.payload.maxDate?.toLowerCase() === 'today' ? '' : 'today'"
                        title="Toggle 'today'"
                      >
                        Today
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        *ngIf="row.payload.maxDate"
                        (click)="row.payload.maxDate = ''"
                        title="Clear max date"
                      >
                        ✕
                      </button>
                    </div>
                    <small class="text-muted" style="font-size: 11px;">
                      Set as <code>today</code> or specific date <code>YYYY-MM-DD</code> (leave blank for no max limit)
                    </small>
                  </div>

                  <div class="col-md-2">
                    <label class="field-label">
                      Month & Year
                      <span class="info-tip" [title]="fieldInfo.monthYear">ⓘ</span>
                    </label>
                    <div class="yn-toggle">
                      <button
                        type="button"
                        [class.y-active]="row.payload.monthYear"
                        (click)="row.payload.monthYear = true"
                      >
                        Y
                      </button>
                      <button
                        type="button"
                        [class.n-active]="!row.payload.monthYear"
                        (click)="row.payload.monthYear = false"
                      >
                        N
                      </button>
                    </div>
                    <small class="text-muted" style="font-size: 11px;">Month picker</small>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="row.payload.type === 'bitcase'">
                <div class="row g-2 mt-2 p-2 border rounded bg-light">
                  <div class="col-12 text-muted fw-semibold small d-flex align-items-center justify-content-between">
                    <span><i class="bi bi-toggles"></i> Bit Case Checkbox Settings</span>
                    <span class="badge bg-secondary">Configurable Base & Direction</span>
                  </div>

                  <div class="col-md-3">
                    <label class="field-label">Base / Default Value</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="e.g. 136"
                      [(ngModel)]="row.payload.baseValue"
                      name="colBaseValue{{i}}"
                    />
                    <small class="text-muted" style="font-size: 11px;">Default value if empty (e.g. 136)</small>
                  </div>

                  <div class="col-md-3">
                    <label class="field-label">Min Base (Offset 0)</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="e.g. 129"
                      [(ngModel)]="row.payload.minBase"
                      name="colMinBase{{i}}"
                    />
                    <small class="text-muted" style="font-size: 11px;">0 checkboxes checked = min base</small>
                  </div>

                  <div class="col-md-3">
                    <label class="field-label">Max Base (All Checked)</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="e.g. 136"
                      [(ngModel)]="row.payload.maxBase"
                      name="colMaxBase{{i}}"
                    />
                    <small class="text-muted" style="font-size: 11px;">All checkboxes checked = max base</small>
                  </div>

                  <div class="col-md-3">
                    <label class="field-label">Value Increment Direction</label>
                    <select
                      class="form-select"
                      [(ngModel)]="row.payload.bitDirection"
                      name="colBitDir{{i}}"
                    >
                      <option value="ltr">Left to Right (1, 2, 4, 8...)</option>
                      <option value="rtl">Right to Left (...8, 4, 2, 1)</option>
                    </select>
                    <small class="text-muted" style="font-size: 11px;">Bit value increment direction</small>
                  </div>

                  <div class="col-md-4">
                    <label class="field-label">Conversion Type <span class="text-danger">*</span></label>
                    <select
                      class="form-select"
                      [(ngModel)]="row.payload.conversionType"
                      name="colConvType{{i}}"
                    >
                      <option *ngFor="let ct of conversionTypes" [value]="ct.value">{{ ct.label }}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="field-label">Bit Count</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="e.g. 3, 12, or 32"
                      min="1"
                      max="64"
                      [(ngModel)]="row.payload.bitCount"
                      name="colBitCount{{i}}"
                    />
                    <small class="text-muted" style="font-size: 11px;">Auto-calculated from Min/Max if empty</small>
                  </div>
                  <div class="col-md-4">
                    <label class="field-label">Bit Whitelist / Labels (Optional)</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="e.g. DTC1, DTC2, DTC3..."
                      [(ngModel)]="row.payload.bitLabelsStr"
                      name="colBitLabels{{i}}"
                    />
                    <small class="text-muted" style="font-size: 11px;">Comma-separated custom bit labels</small>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="row.optionsMode === 'api' && row.payload.options as opts"
              >
                <div class="row g-2 mt-2">
                  <div class="col-md-3">
                    <label class="field-label"
                      >Options API URL
                      <span class="info-tip" [title]="fieldInfo.optionsApi"
                        >ⓘ</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="opts.url"
                      name="optUrl{{i}}"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="field-label"
                      >Options Payload
                      <span class="info-tip" [title]="fieldInfo.optionsPayload"
                        >ⓘ</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="opts.payloadStr"
                      placeholder='e.g. {"type": 1}'
                      name="optPayload{{i}}"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="field-label"
                      >Value key
                      <span class="info-tip" [title]="fieldInfo.optionsKey"
                        >ⓘ</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="id"
                      [(ngModel)]="opts.key"
                      name="optKey{{i}}"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="field-label"
                      >Label key
                      <span class="info-tip" [title]="fieldInfo.optionsValue"
                        >ⓘ</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="name"
                    [(ngModel)]="opts.value"
                      name="optVal{{i}}"
                    />
                  </div>
                </div>

                <div class="col-md-12 d-flex justify-content-end mt-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="toggleExtraOption(opts)"
                  >
                    {{ opts.extraOption ? '✕ Remove Extra Option' : '+ Add Extra Option (ALL)' }}
                  </button>
                </div>

                <div class="row g-2 mt-1 p-2 border rounded bg-light" *ngIf="opts.extraOption">
                  <div class="col-md-6">
                    <label class="field-label">Extra Option Value (e.g. ALL)</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="opts.extraOption.id"
                      placeholder="e.g. ALL"
                      name="optExtraId{{i}}"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="field-label">Extra Option Label (e.g. All Units)</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="opts.extraOption.name"
                      placeholder="e.g. All Units"
                      name="optExtraName{{i}}"
                    />
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="row.optionsMode === 'static' && row.payload.options as opts"
              >
                <div class="mt-3">
                  <label class="field-label">Static options</label>
                  <div
                    class="d-flex gap-2 mb-2"
                    *ngFor="let opt of opts.list; let j = index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="id"
                      [(ngModel)]="opt.id"
                      name="optId{{i}}_{{j}}"
                    />
                    <input
                      type="text"
                      class="form-control"
                      placeholder="name"
                      [(ngModel)]="opt.name"
                      name="optName{{i}}_{{j}}"
                    />
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      (click)="removeStaticOption(row, j)"
                    >
                      ✕
                    </button>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="addStaticOption(row)"
                  >
                    + Add option
                  </button>
                </div>
              </ng-container>
            </div>

            <!-- Section 4: Value Mapping & Click Action -->
            <div class="column-section-box">
              <div class="column-section-title">
                <span>Value Mapping &amp; Click Interactions</span>
              </div>
              <div>
                <div class="field-group-title">
                  Value mapping
                  <span class="info-tip" [title]="fieldInfo.mapping">ⓘ</span>
                </div>
                <div class="yn-toggle mb-2">
                  <button
                    type="button"
                    [class.y-active]="!!row.payload.mapping"
                    (click)="onMappingToggle(row, true)"
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    [class.n-active]="!row.payload.mapping"
                    (click)="onMappingToggle(row, false)"
                  >
                    N
                  </button>
                </div>
                <div class="row g-2" *ngIf="row.payload.mapping as map">
                  <div class="col-md-4">
                    <label class="field-label">Mapping URL</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="map.mappingUrl"
                      name="mapUrl{{i}}"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="field-label"
                      >Mapping Payload
                      <span class="info-tip" [title]="fieldInfo.mappingPayload">ⓘ</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="map.payloadStr"
                      placeholder='e.g. {"status": 1}'
                      name="mapPayload{{i}}"
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="field-label">Mapping key</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="map.mappingKey"
                      name="mapKey{{i}}"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Mapping value</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="map.mappingValue"
                      name="mapVal{{i}}"
                    />
                  </div>
                  <div class="col-12">
                    <label class="field-label"
                      >Static value mapping (optional)</label
                    >
                    <div
                      class="d-flex gap-2 mb-2"
                      *ngFor="let entry of row.mappingEntries; let j = index"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="raw value (e.g. N)"
                        [(ngModel)]="entry.key"
                        (ngModelChange)="onMappingEntryChange(row)"
                        name="mapEntryKey{{i}}_{{j}}"
                      />
                      <input
                        type="text"
                        class="form-control"
                        placeholder="display value (e.g. New)"
                        [(ngModel)]="entry.value"
                        (ngModelChange)="onMappingEntryChange(row)"
                        name="mapEntryVal{{i}}_{{j}}"
                      />
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        (click)="removeMappingEntry(row, j)"
                      >
                        ✕
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      (click)="addMappingEntry(row)"
                    >
                      + Add mapping
                    </button>
                  </div>
                </div>

                <div class="field-group-title mt-3">
                  Click <span class="info-tip" [title]="fieldInfo.click">ⓘ</span>
                </div>
                <div class="yn-toggle mb-2">
                  <button
                    type="button"
                    [class.y-active]="!!row.payload.click"
                    (click)="onClickToggle(row, true)"
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    [class.n-active]="!row.payload.click"
                    (click)="onClickToggle(row, false)"
                  >
                    N
                  </button>
                </div>

                <ng-container *ngIf="row.payload.click as clk">
                  <div class="basis-toggle mb-2">
                    <button
                      type="button"
                      [class.active]="clk.type === 'redirect'"
                      (click)="onClickTypeChange(row, 'redirect')"
                    >
                      Redirect
                    </button>
                    <button
                      type="button"
                      [class.active]="clk.type === 'popup'"
                      (click)="onClickTypeChange(row, 'popup')"
                    >
                      Popup
                    </button>
                    <button
                      type="button"
                      [class.active]="clk.type === 'openForm'"
                      (click)="onClickTypeChange(row, 'openForm')"
                    >
                      Open Form
                    </button>
                  </div>

                  <div *ngIf="clk.type === 'redirect'">
                    <div class="row g-2">
                      <div class="col-md-6">
                        <label class="field-label"
                          >Redirect URL
                          <span class="info-tip" [title]="fieldInfo.clickRedirect"
                            >ⓘ</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="clk.redirectUrl"
                          name="clickRedirect{{i}}"
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="field-label"
                          >Redirect Payload
                          <span class="info-tip" [title]="fieldInfo.clickPayload"
                            >ⓘ</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="clk.payloadStr"
                          placeholder='e.g. {"mode": "view"}'
                          name="clickPayload{{i}}"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    class="row g-2"
                    *ngIf="clk.type === 'popup' && clk.popup as popup"
                  >
                    <div class="col-md-4">
                      <label class="field-label">Popup title</label>
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="popup.title"
                        name="popupTitle{{i}}"
                      />
                    </div>
                    <div class="col-md-2">
                      <label class="field-label">Popup size</label>
                      <select
                        class="form-select"
                        [(ngModel)]="popup.size"
                        name="popupSize{{i}}"
                      >
                        <option value="sm">Small</option>
                        <option value="md">Medium</option>
                        <option value="lg">Large</option>
                        <option value="xl">Extra large</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="field-label"
                        >Content URL
                        <span class="info-tip" [title]="fieldInfo.clickPopup"
                          >ⓘ</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="popup.contentUrl"
                        name="popupUrl{{i}}"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="field-label"
                        >Popup Payload
                        <span
                          class="info-tip"
                          [title]="fieldInfo.clickPayload"
                          >ⓘ</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="popup.payloadStr"
                        placeholder='e.g. {"type": "details"}'
                        name="popupPayload{{i}}"
                      />
                    </div>
                  </div>

                  <div *ngIf="clk.type === 'openForm'" class="mt-3">
                    <div class="row g-2 mb-3">
                      <div class="col-md-6">
                        <label class="field-label">API Key / Endpoint</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="clk.apiKey"
                          name="clickApiKey{{i}}"
                          placeholder="e.g. Save-Column-Data"
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="field-label"
                          >Static Payload / Params
                          <span class="info-tip" [title]="fieldInfo.clickPayload">ⓘ</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="clk.payloadStr"
                          placeholder='e.g. {"action": "submit"}'
                          name="clickFormPayload{{i}}"
                        />
                      </div>

                      <!-- Select Table Row Keys to Send in Payload -->
                      <div class="col-12">
                        <label class="field-label mb-1">
                          Table Row Keys to Send in Payload
                          <span class="text-muted fw-normal small">(keys from clicked row to merge into POST payload)</span>
                        </label>
                        <input
                          type="text"
                          class="form-control font-monospace mb-1"
                          [(ngModel)]="clk.rowKeysStr"
                          placeholder="e.g. id, meter_type, name"
                          name="clickRowKeys{{i}}"
                        />
                        <div class="d-flex flex-wrap align-items-center gap-1 mt-1" *ngIf="getExistingKeysList().length > 0">
                          <span class="text-muted small me-1" style="font-size: 11px;">Pick Row Keys:</span>
                          <button
                            type="button"
                            class="badge border py-1 px-2 text-decoration-none"
                            [ngClass]="isRowKeySelected(clk, k) ? 'bg-primary text-white' : 'bg-light text-primary'"
                            style="font-family: monospace; font-size: 11px; cursor: pointer;"
                            *ngFor="let k of getExistingKeysList()"
                            (click)="toggleRowKeyForClick(clk, k)"
                            title="Click to toggle {{ k }} in payload"
                          >
                            {{ isRowKeySelected(clk, k) ? '✓ ' + k : '+ ' + k }}
                          </button>
                        </div>
                      </div>

                      <!-- Direct Action / Warning Mode -->
                      <div class="col-12">
                        <div class="p-2 border rounded bg-light mt-1">
                          <div class="form-check form-switch mb-1">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="confirmActionSwitch{{i}}"
                              [(ngModel)]="clk.confirmAction"
                              name="confirmActionSwitch{{i}}"
                            />
                            <label class="form-check-label fw-bold small" [for]="'confirmActionSwitch' + i">
                              Direct Action (Show warning confirmation only, No Form Modal)
                            </label>
                          </div>
                          <div *ngIf="clk.confirmAction" class="mt-2">
                            <label class="field-label">Warning Confirmation Message</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="clk.warningMessage"
                              placeholder="Are you sure you want to run this action?"
                              name="clkWarnMsg{{i}}"
                            />
                            <small class="text-muted d-block mt-1">
                              When clicked, user is prompted with this warning and the static payload + selected row keys are directly POSTed to the API.
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="nested-form-container p-3 rounded" *ngIf="!clk.confirmAction">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <div class="field-group-title m-0 p-0 border-0">Column Form Fields</div>
                          <div class="text-muted small">Fields shown in the modal form opened upon clicking this column cell. Leave empty for direct warning action.</div>
                        </div>
                        <div class="d-flex gap-2">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                            (click)="openHtmlImportModal(clk, 'columnForm')"
                            title="Import fields from working site HTML dialog snippet"
                          >
                            <i class="bi bi-filetype-html"></i> Import from HTML
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            (click)="addFieldTo(getColumnFormFields(clk))"
                          >
                            + Add Form Field
                          </button>
                        </div>
                      </div>
                      <ng-container
                        *ngTemplateOutlet="fieldsEditor; context: { fields: getColumnFormFields(clk) }"
                      ></ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <!-- Section 5: Role Permissions & Access Control -->
            <div class="column-section-box">
              <div class="column-section-title">
                <span>Role Permissions &amp; Access Control</span>
              </div>
              <div class="text-muted small mb-3">
                Configure role-based column visibility in grid, modal visibility in Add/Edit, and field readonly locks.
              </div>

              <div class="row g-3">
                <!-- Roles (hide column) -->
                <div class="col-md-4">
                  <div class="field-group-title">
                    Roles (hide column) <span class="info-tip" [title]="fieldInfo.role">ⓘ</span>
                  </div>
                  <div *ngIf="loadingRoles" class="text-muted small">
                    Loading roles…
                  </div>
                  <div class="mb-3" *ngIf="!loadingRoles">
                    <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                      <button
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                        ngbDropdownToggle
                      >
                        <span class="text-truncate">{{ getSelectedRoleLabel(row.payload.role, 'Select roles to hide column...') }}</span>
                        <span class="badge bg-primary role-btn-badge" *ngIf="row.payload.role?.length">{{ row.payload.role.length }}</span>
                                              <span class="role-caret">&#9660;</span>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                        <div class="px-1 pb-2 mb-1 border-bottom">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            placeholder="Search roles..."
                            [(ngModel)]="roleSearchTerm['col_role_' + i]"
                            name="colRoleSearch{{i}}"
                            (click)="$event.stopPropagation()"
                          />
                          <div class="d-flex justify-content-between">
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-decoration-none"
                              (click)="selectAllRolesInList(row.payload, 'role', 'col_role_' + i)"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                              (click)="deselectAllRolesInList(row.payload, 'role', 'col_role_' + i)"
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div style="max-height: 180px; overflow-y: auto;">
                          <div *ngIf="getFilteredRoles(roleSearchTerm['col_role_' + i]).length === 0" class="text-muted small p-2 text-center">
                            No roles found
                          </div>
                          <div
                            class="dropdown-item-check"
                            *ngFor="let r of getFilteredRoles(roleSearchTerm['col_role_' + i])"
                            (click)="toggleRoleInList(row.payload, 'role', r.type); $event.stopPropagation()"
                          >
                            <input
                              class="form-check-input pointer-events-none"
                              type="checkbox"
                              [checked]="isRoleInList(row.payload.role, r.type)"
                              tabindex="-1"
                            />
                            <span class="dropdown-item-label small">
                              {{ r.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="row.payload.role?.length">
                      <span
                        class="badge d-flex align-items-center gap-1 px-2 py-1"
                        *ngFor="let roleType of row.payload.role"
                      >
                        {{ getRoleNameByType(roleType) }}
                        <button
                          type="button"
                          class="btn-close btn-close-xs"
                          aria-label="Remove"
                          (click)="removeRoleFromList(row.payload, 'role', roleType)"
                        ></button>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Roles — Add -->
                <div class="col-md-4">
                  <div class="field-group-title">
                    Roles — Add
                    <span class="info-tip" [title]="fieldInfo.roleAdd">ⓘ</span>
                  </div>
                  <div *ngIf="loadingRoles" class="text-muted small">
                    Loading roles…
                  </div>
                  <div class="mb-3" *ngIf="!loadingRoles">
                    <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                      <button
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                        ngbDropdownToggle
                      >
                        <span class="text-truncate">{{ getSelectedRoleLabel(row.payload.role_add, 'Select roles to hide in Add...') }}</span>
                        <span class="badge bg-primary role-btn-badge" *ngIf="row.payload.role_add?.length">{{ row.payload.role_add.length }}</span>
                                              <span class="role-caret">&#9660;</span>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                        <div class="px-1 pb-2 mb-1 border-bottom">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            placeholder="Search roles..."
                            [(ngModel)]="roleSearchTerm['col_role_add_' + i]"
                            name="colRoleAddSearch{{i}}"
                            (click)="$event.stopPropagation()"
                          />
                          <div class="d-flex justify-content-between">
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-decoration-none"
                              (click)="selectAllRolesInList(row.payload, 'role_add', 'col_role_add_' + i)"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                              (click)="deselectAllRolesInList(row.payload, 'role_add', 'col_role_add_' + i)"
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div style="max-height: 180px; overflow-y: auto;">
                          <div *ngIf="getFilteredRoles(roleSearchTerm['col_role_add_' + i]).length === 0" class="text-muted small p-2 text-center">
                            No roles found
                          </div>
                          <div
                            class="dropdown-item-check"
                            *ngFor="let r of getFilteredRoles(roleSearchTerm['col_role_add_' + i])"
                            (click)="toggleRoleInList(row.payload, 'role_add', r.type); $event.stopPropagation()"
                          >
                            <input
                              class="form-check-input pointer-events-none"
                              type="checkbox"
                              [checked]="isRoleInList(row.payload.role_add, r.type)"
                              tabindex="-1"
                            />
                            <span class="dropdown-item-label small">
                              {{ r.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="row.payload.role_add?.length">
                      <span
                        class="badge d-flex align-items-center gap-1 px-2 py-1"
                        *ngFor="let roleType of row.payload.role_add"
                      >
                        {{ getRoleNameByType(roleType) }}
                        <button
                          type="button"
                          class="btn-close btn-close-xs"
                          aria-label="Remove"
                          (click)="removeRoleFromList(row.payload, 'role_add', roleType)"
                        ></button>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Roles — Edit -->
                <div class="col-md-4">
                  <div class="field-group-title">
                    Roles — Edit
                    <span class="info-tip" [title]="fieldInfo.roleEdit">ⓘ</span>
                  </div>
                  <div *ngIf="loadingRoles" class="text-muted small">
                    Loading roles…
                  </div>
                  <div class="mb-3" *ngIf="!loadingRoles">
                    <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                      <button
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                        ngbDropdownToggle
                      >
                        <span class="text-truncate">{{ getSelectedRoleLabel(row.payload.role_edit, 'Select roles to hide in Edit...') }}</span>
                        <span class="badge bg-primary role-btn-badge" *ngIf="row.payload.role_edit?.length">{{ row.payload.role_edit.length }}</span>
                                              <span class="role-caret">&#9660;</span>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                        <div class="px-1 pb-2 mb-1 border-bottom">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            placeholder="Search roles..."
                            [(ngModel)]="roleSearchTerm['col_role_edit_' + i]"
                            name="colRoleEditSearch{{i}}"
                            (click)="$event.stopPropagation()"
                          />
                          <div class="d-flex justify-content-between">
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-decoration-none"
                              (click)="selectAllRolesInList(row.payload, 'role_edit', 'col_role_edit_' + i)"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                              (click)="deselectAllRolesInList(row.payload, 'role_edit', 'col_role_edit_' + i)"
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div style="max-height: 180px; overflow-y: auto;">
                          <div *ngIf="getFilteredRoles(roleSearchTerm['col_role_edit_' + i]).length === 0" class="text-muted small p-2 text-center">
                            No roles found
                          </div>
                          <div
                            class="dropdown-item-check"
                            *ngFor="let r of getFilteredRoles(roleSearchTerm['col_role_edit_' + i])"
                            (click)="toggleRoleInList(row.payload, 'role_edit', r.type); $event.stopPropagation()"
                          >
                            <input
                              class="form-check-input pointer-events-none"
                              type="checkbox"
                              [checked]="isRoleInList(row.payload.role_edit, r.type)"
                              tabindex="-1"
                            />
                            <span class="dropdown-item-label small">
                              {{ r.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="row.payload.role_edit?.length">
                      <span
                        class="badge d-flex align-items-center gap-1 px-2 py-1"
                        *ngFor="let roleType of row.payload.role_edit"
                      >
                        {{ getRoleNameByType(roleType) }}
                        <button
                          type="button"
                          class="btn-close btn-close-xs"
                          aria-label="Remove"
                          (click)="removeRoleFromList(row.payload, 'role_edit', roleType)"
                        ></button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row g-3 mt-1">
                <!-- Roles — Readonly -->
                <div class="col-md-4">
                  <div class="field-group-title">
                    Roles — Readonly
                    <span class="info-tip" [title]="fieldInfo.roleReadonly">ⓘ</span>
                  </div>
                  <div *ngIf="loadingRoles" class="text-muted small">
                    Loading roles…
                  </div>
                  <div class="mb-3" *ngIf="!loadingRoles">
                    <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                      <button
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                        ngbDropdownToggle
                      >
                        <span class="text-truncate">{{ getSelectedRoleLabel(row.payload.role_readonly, 'Select roles for readonly...') }}</span>
                        <span class="badge bg-primary role-btn-badge" *ngIf="row.payload.role_readonly?.length">{{ row.payload.role_readonly.length }}</span>
                                              <span class="role-caret">&#9660;</span>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                        <div class="px-1 pb-2 mb-1 border-bottom">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            placeholder="Search roles..."
                            [(ngModel)]="roleSearchTerm['col_role_readonly_' + i]"
                            name="colRoleReadonlySearch{{i}}"
                            (click)="$event.stopPropagation()"
                          />
                          <div class="d-flex justify-content-between">
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-decoration-none"
                              (click)="selectAllRolesInList(row.payload, 'role_readonly', 'col_role_readonly_' + i)"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                              (click)="deselectAllRolesInList(row.payload, 'role_readonly', 'col_role_readonly_' + i)"
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div style="max-height: 180px; overflow-y: auto;">
                          <div *ngIf="getFilteredRoles(roleSearchTerm['col_role_readonly_' + i]).length === 0" class="text-muted small p-2 text-center">
                            No roles found
                          </div>
                          <div
                            class="dropdown-item-check"
                            *ngFor="let r of getFilteredRoles(roleSearchTerm['col_role_readonly_' + i])"
                            (click)="toggleRoleInList(row.payload, 'role_readonly', r.type); $event.stopPropagation()"
                          >
                            <input
                              class="form-check-input pointer-events-none"
                              type="checkbox"
                              [checked]="isRoleInList(row.payload.role_readonly, r.type)"
                              tabindex="-1"
                            />
                            <span class="dropdown-item-label small">
                              {{ r.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="row.payload.role_readonly?.length">
                      <span
                        class="badge d-flex align-items-center gap-1 px-2 py-1"
                        *ngFor="let roleType of row.payload.role_readonly"
                      >
                        {{ getRoleNameByType(roleType) }}
                        <button
                          type="button"
                          class="btn-close btn-close-xs"
                          aria-label="Remove"
                          (click)="removeRoleFromList(row.payload, 'role_readonly', roleType)"
                        ></button>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Roles — Readonly (Add) -->
                <div class="col-md-4">
                  <div class="field-group-title">
                    Roles — Readonly (Add)
                    <span class="info-tip" [title]="fieldInfo.roleReadonlyAdd">ⓘ</span>
                  </div>
                  <div *ngIf="loadingRoles" class="text-muted small">
                    Loading roles…
                  </div>
                  <div class="mb-3" *ngIf="!loadingRoles">
                    <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                      <button
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                        ngbDropdownToggle
                      >
                        <span class="text-truncate">{{ getSelectedRoleLabel(row.payload.role_readonly_add, 'Select roles for readonly in Add...') }}</span>
                        <span class="badge bg-primary role-btn-badge" *ngIf="row.payload.role_readonly_add?.length">{{ row.payload.role_readonly_add.length }}</span>
                                              <span class="role-caret">&#9660;</span>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                        <div class="px-1 pb-2 mb-1 border-bottom">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            placeholder="Search roles..."
                            [(ngModel)]="roleSearchTerm['col_role_readonly_add_' + i]"
                            name="colRoleReadonlyAddSearch{{i}}"
                            (click)="$event.stopPropagation()"
                          />
                          <div class="d-flex justify-content-between">
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-decoration-none"
                              (click)="selectAllRolesInList(row.payload, 'role_readonly_add', 'col_role_readonly_add_' + i)"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                              (click)="deselectAllRolesInList(row.payload, 'role_readonly_add', 'col_role_readonly_add_' + i)"
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div style="max-height: 180px; overflow-y: auto;">
                          <div *ngIf="getFilteredRoles(roleSearchTerm['col_role_readonly_add_' + i]).length === 0" class="text-muted small p-2 text-center">
                            No roles found
                          </div>
                          <div
                            class="dropdown-item-check"
                            *ngFor="let r of getFilteredRoles(roleSearchTerm['col_role_readonly_add_' + i])"
                            (click)="toggleRoleInList(row.payload, 'role_readonly_add', r.type); $event.stopPropagation()"
                          >
                            <input
                              class="form-check-input pointer-events-none"
                              type="checkbox"
                              [checked]="isRoleInList(row.payload.role_readonly_add, r.type)"
                              tabindex="-1"
                            />
                            <span class="dropdown-item-label small">
                              {{ r.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="row.payload.role_readonly_add?.length">
                      <span
                        class="badge d-flex align-items-center gap-1 px-2 py-1"
                        *ngFor="let roleType of row.payload.role_readonly_add"
                      >
                        {{ getRoleNameByType(roleType) }}
                        <button
                          type="button"
                          class="btn-close btn-close-xs"
                          aria-label="Remove"
                          (click)="removeRoleFromList(row.payload, 'role_readonly_add', roleType)"
                        ></button>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Roles — Readonly (Edit) -->
                <div class="col-md-4">
                  <div class="field-group-title">
                    Roles — Readonly (Edit)
                    <span class="info-tip" [title]="fieldInfo.roleReadonlyEdit">ⓘ</span>
                  </div>
                  <div *ngIf="loadingRoles" class="text-muted small">
                    Loading roles…
                  </div>
                  <div class="mb-3" *ngIf="!loadingRoles">
                    <div class="btn-group w-100" ngbDropdown [autoClose]="'outside'">
                      <button
                        type="button"
                        class="btn btn-outline-secondary dropdown-toggle w-100 role-dropdown-btn"
                        ngbDropdownToggle
                      >
                        <span class="text-truncate">{{ getSelectedRoleLabel(row.payload.role_readonly_edit, 'Select roles for readonly in Edit...') }}</span>
                        <span class="badge bg-primary role-btn-badge" *ngIf="row.payload.role_readonly_edit?.length">{{ row.payload.role_readonly_edit.length }}</span>
                                              <span class="role-caret">&#9660;</span>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                        <div class="px-1 pb-2 mb-1 border-bottom">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            placeholder="Search roles..."
                            [(ngModel)]="roleSearchTerm['col_role_readonly_edit_' + i]"
                            name="colRoleReadonlyEditSearch{{i}}"
                            (click)="$event.stopPropagation()"
                          />
                          <div class="d-flex justify-content-between">
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-decoration-none"
                              (click)="selectAllRolesInList(row.payload, 'role_readonly_edit', 'col_role_readonly_edit_' + i)"
                            >
                              Select All
                            </button>
                            <button
                              type="button"
                              class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                              (click)="deselectAllRolesInList(row.payload, 'role_readonly_edit', 'col_role_readonly_edit_' + i)"
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                        <div style="max-height: 180px; overflow-y: auto;">
                          <div *ngIf="getFilteredRoles(roleSearchTerm['col_role_readonly_edit_' + i]).length === 0" class="text-muted small p-2 text-center">
                            No roles found
                          </div>
                          <div
                            class="dropdown-item-check"
                            *ngFor="let r of getFilteredRoles(roleSearchTerm['col_role_readonly_edit_' + i])"
                            (click)="toggleRoleInList(row.payload, 'role_readonly_edit', r.type); $event.stopPropagation()"
                          >
                            <input
                              class="form-check-input pointer-events-none"
                              type="checkbox"
                              [checked]="isRoleInList(row.payload.role_readonly_edit, r.type)"
                              tabindex="-1"
                            />
                            <span class="dropdown-item-label small">
                              {{ r.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="row.payload.role_readonly_edit?.length">
                      <span
                        class="badge d-flex align-items-center gap-1 px-2 py-1"
                        *ngFor="let roleType of row.payload.role_readonly_edit"
                      >
                        {{ getRoleNameByType(roleType) }}
                        <button
                          type="button"
                          class="btn-close btn-close-xs"
                          aria-label="Remove"
                          (click)="removeRoleFromList(row.payload, 'role_readonly_edit', roleType)"
                        ></button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button type="button" class="add-column-btn" (click)="addTableColumn()">
        + Add column
      </button>
    </ng-container>
  </div>

  <!-- Step 6: Form builder -->
  <div class="step-section" *ngIf="componentType === 'form' && basis">
    <div class="step-label">Step 6 · Form Fields</div>
    <ng-container
      *ngTemplateOutlet="fieldsEditor; context: { fields: formFields }"
    ></ng-container>
  </div>

  <!-- Step 6: Modal Form builder -->
  <div class="step-section" *ngIf="componentType === 'modalform' && basis">
    <div class="step-label">Step 6 · Modal Form</div>

    <div class="row g-2 mb-3">
      <div class="col-md-8">
        <label class="form-label">Modal Title</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="modalForm.modalTitle"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label">Modal Size</label>
        <select class="form-select" [(ngModel)]="modalForm.modalSize">
          <option value="sm">Small</option>
          <option value="md">Medium</option>
          <option value="lg">Large</option>
          <option value="xl">Extra Large</option>
        </select>
      </div>
    </div>

    <ng-container
      *ngTemplateOutlet="fieldsEditor; context: { fields: modalForm.fields }"
    ></ng-container>
  </div>

  <div class="action-bar" *ngIf="componentType">
    <span class="action-bar-status">
      <span class="status-dot"></span>
      {{ canSave ? 'Ready to save' : 'Complete the steps above to save' }}
    </span>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!canSave"
      (click)="saveForm()"
    >
      {{ componentType === 'table' ? 'Save configuration' : 'Save & Download JSON' }}
    </button>
  </div>

</div>


<!-- Shared field editor, used for Table Column openForm, Form, and ModalForm -->
<ng-template #fieldsEditor let-fields="fields">
  <div class="field-list" *ngIf="fields && fields.length">
    <div
      class="field-card"
      *ngFor="let field of fields; let i = index"
    >
      <div class="field-card-header" [class.expanded]="field.expanded" (click)="toggleFieldExpanded(field)">
        <span class="column-drag-index">{{ i + 1 }}</span>
        <span class="column-chevron" [class.open]="field.expanded">▶</span>
        <span
          class="column-key-chip"
          (click)="copyColumnKey(field.id, $event)"
          [title]="field.id ? 'Click to copy key: ' + field.id : 'No key to copy'"
        >
          <i class="bi bi-clipboard me-1" *ngIf="field.id"></i>
          {{ field.id || '(no key)' }}
        </span>
        <span class="column-title-preview">{{ field.placeholder || 'Untitled field' }}</span>
        
        <span class="field-type-badge ms-2">
          {{ field.type === 'dropdownUrl' ? 'API Dropdown' : field.type === 'dropdownList' ? 'List Dropdown' : (field.type || 'text') }}
        </span>

        <span class="column-flag-dots ms-auto">
          <span class="flag-dot on-edit" *ngIf="field.required">REQ</span>
          <span class="flag-dot on-readonly" *ngIf="field.readonly">RO</span>
          <span class="flag-dot" *ngIf="field.view === false">HIDDEN</span>
        </span>

        <button
          type="button"
          class="btn btn-sm btn-outline-danger ms-2"
          (click)="removeFieldFrom(fields, i); $event.stopPropagation()"
          title="Remove field"
        >
          ✕
        </button>
      </div>

      <div class="field-card-body" *ngIf="field.expanded">
        <div class="row g-2">
          <div class="col-md-4">
            <label class="field-label">Field ID (Key) <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              placeholder="e.g. consumer_name"
              [(ngModel)]="field.id"
              name="fId{{i}}"
            />
          </div>

          <div class="col-md-4">
            <label class="field-label">Label / Placeholder <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              placeholder="e.g. Consumer Name"
              [(ngModel)]="field.placeholder"
              name="fPlaceholder{{i}}"
            />
          </div>

          <div class="col-md-4">
            <label class="field-label">Field Type</label>
            <select
              class="form-select"
              [(ngModel)]="field.type"
              (ngModelChange)="onFormFieldTypeChange(field)"
              name="fType{{i}}"
            >
              <option value="text">Text</option>
              <option value="number">Number</option>
              <option value="date">Date</option>
              <option value="dropdownUrl">Dropdown (API)</option>
              <option value="dropdownList">Dropdown (List)</option>
              <option value="bitcase">Bit Case Checkbox</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="field-label">CSS Class</label>
            <input
              type="text"
              class="form-control"
              placeholder="e.g. col-md-6"
              [(ngModel)]="field.class"
              name="fClass{{i}}"
            />
          </div>

          <div class="col-md-4">
            <label class="field-label">Regex Pattern</label>
            <input
              type="text"
              class="form-control"
              placeholder="e.g. ^[0-9]{10}$"
              [(ngModel)]="field.regex"
              name="fRegex{{i}}"
            />
          </div>

          <div class="col-md-4">
            <label class="field-label">Regex Error Message</label>
            <input
              type="text"
              class="form-control"
              placeholder="e.g. Invalid value entered"
              [(ngModel)]="field.regexMessage"
              name="fRegexMsg{{i}}"
            />
          </div>

          <ng-container *ngIf="field.type === 'date'">
            <div class="col-12">
              <div class="row g-2 p-2 border rounded bg-light">
                <div class="col-12 text-muted fw-semibold small d-flex align-items-center justify-content-between">
                  <span><i class="bi bi-calendar-date"></i> Date Picker Range & Limit Settings</span>
                  <span class="badge bg-secondary">Min / Max Constraints</span>
                </div>

                <div class="col-md-5">
                  <label class="field-label">
                    Min Date
                    <span class="info-tip" [title]="fieldInfo.minDate">ⓘ</span>
                  </label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="e.g. today or 2026-01-01"
                      [(ngModel)]="field.minDate"
                      name="fMinDate{{i}}"
                    />
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      [class.active]="field.minDate?.toLowerCase() === 'today'"
                      (click)="field.minDate = field.minDate?.toLowerCase() === 'today' ? '' : 'today'"
                      title="Toggle 'today'"
                    >
                      Today
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      *ngIf="field.minDate"
                      (click)="field.minDate = ''"
                      title="Clear min date"
                    >
                      ✕
                    </button>
                  </div>
                  <small class="text-muted" style="font-size: 11px;">
                    Set as <code>today</code> or specific date <code>YYYY-MM-DD</code> (leave blank for no min limit)
                  </small>
                </div>

                <div class="col-md-5">
                  <label class="field-label">
                    Max Date
                    <span class="info-tip" [title]="fieldInfo.maxDate">ⓘ</span>
                  </label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="e.g. today or 2026-12-31"
                      [(ngModel)]="field.maxDate"
                      name="fMaxDate{{i}}"
                    />
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      [class.active]="field.maxDate?.toLowerCase() === 'today'"
                      (click)="field.maxDate = field.maxDate?.toLowerCase() === 'today' ? '' : 'today'"
                      title="Toggle 'today'"
                    >
                      Today
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      *ngIf="field.maxDate"
                      (click)="field.maxDate = ''"
                      title="Clear max date"
                    >
                      ✕
                    </button>
                  </div>
                  <small class="text-muted" style="font-size: 11px;">
                    Set as <code>today</code> or specific date <code>YYYY-MM-DD</code> (leave blank for no max limit)
                  </small>
                </div>

                <div class="col-md-2">
                  <label class="field-label">
                    Month & Year
                    <span class="info-tip" [title]="fieldInfo.monthYear">ⓘ</span>
                  </label>
                  <div class="yn-toggle">
                    <button
                      type="button"
                      [class.y-active]="field.monthYear"
                      (click)="field.monthYear = true"
                    >
                      Y
                    </button>
                    <button
                      type="button"
                      [class.n-active]="!field.monthYear"
                      (click)="field.monthYear = false"
                    >
                      N
                    </button>
                  </div>
                  <small class="text-muted" style="font-size: 11px;">Month picker</small>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="field.type === 'bitcase'">
            <div class="col-12">
              <div class="row g-2 p-2 border rounded bg-light">
                <div class="col-12 text-muted fw-semibold small d-flex align-items-center justify-content-between">
                  <span><i class="bi bi-toggles"></i> Bit Case Checkbox Settings</span>
                  <span class="badge bg-secondary">Configurable Base & Direction</span>
                </div>

                <div class="col-md-3">
                  <label class="field-label">Base / Default Value</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="e.g. 136"
                    [(ngModel)]="field.baseValue"
                    name="fBaseValue{{i}}"
                  />
                  <small class="text-muted" style="font-size: 11px;">Default value if empty (e.g. 136)</small>
                </div>

                <div class="col-md-3">
                  <label class="field-label">Min Base (Offset 0)</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="e.g. 129"
                    [(ngModel)]="field.minBase"
                    name="fMinBase{{i}}"
                  />
                  <small class="text-muted" style="font-size: 11px;">0 checkboxes checked = min base</small>
                </div>

                <div class="col-md-3">
                  <label class="field-label">Max Base (All Checked)</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="e.g. 136"
                    [(ngModel)]="field.maxBase"
                    name="fMaxBase{{i}}"
                  />
                  <small class="text-muted" style="font-size: 11px;">All checkboxes checked = max base</small>
                </div>

                <div class="col-md-3">
                  <label class="field-label">Value Increment Direction</label>
                  <select
                    class="form-select"
                    [(ngModel)]="field.bitDirection"
                    name="fBitDir{{i}}"
                  >
                    <option value="ltr">Left to Right (1, 2, 4, 8...)</option>
                    <option value="rtl">Right to Left (...8, 4, 2, 1)</option>
                  </select>
                  <small class="text-muted" style="font-size: 11px;">Bit value increment direction</small>
                </div>

                <div class="col-md-4">
                  <label class="field-label">Checkbox Count (Bit Count) <span class="text-danger">*</span></label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="e.g. 3, 12, or 32"
                    min="1"
                    max="64"
                    [(ngModel)]="field.bitCount"
                    name="fBitCountInput{{i}}"
                  />
                  <small class="text-muted" style="font-size: 11px;">Auto-calculated from Min/Max if empty</small>
                </div>
                <div class="col-md-4">
                  <label class="field-label">Payload Format</label>
                  <select
                    class="form-select"
                    [(ngModel)]="field.conversionType"
                    name="fConvType{{i}}"
                  >
                    <option *ngFor="let ct of conversionTypes" [value]="ct.value">{{ ct.label }}</option>
                  </select>
                  <small class="text-muted" style="font-size: 11px;">Default: Decimal</small>
                </div>
                <div class="col-md-4">
                  <label class="field-label">Bit Whitelist / Labels (Optional)</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="e.g. DTC1, DTC2, DTC3..."
                    [(ngModel)]="field.bitLabelsStr"
                    name="fBitLabels{{i}}"
                  />
                  <small class="text-muted" style="font-size: 11px;">Comma-separated custom bit labels</small>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Row Data Auto-Fill Mapping -->
          <div class="col-md-6" *ngIf="getExistingKeysList().length > 0">
            <label class="field-label">
              <i class="bi bi-box-arrow-in-down-left text-primary me-1"></i>
              Fill Value from Table Row Column
              <span class="info-tip" title="Pre-fill this form field with the value from an existing column in the clicked table row">ⓘ</span>
            </label>
            <select class="form-select" [(ngModel)]="field.fillFromKey" name="fFillKey{{i}}">
              <option [value]="''">-- Default (match by ID / Key: {{ field.id || 'none' }}) --</option>
              <option *ngFor="let k of getExistingKeysList()" [value]="k">
                {{ k }}
              </option>
            </select>
            <small class="text-muted" style="font-size: 11px;">
              {{ field.fillFromKey ? 'Pre-fills with row["' + field.fillFromKey + '"]' : 'Pre-fills with row["' + (field.id || 'id') + '"] if present' }}
            </small>
          </div>

          <!-- Conditional Visibility (Show field based on table row value) -->
          <div class="col-12 mt-2" *ngIf="getExistingKeysList().length > 0">
            <div class="p-2 border rounded bg-light">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="field-group-title m-0 p-0 border-0 d-flex align-items-center gap-1">
                  <i class="bi bi-diagram-3 text-primary"></i>
                  <span>Conditional Visibility (Show field / checkboxes based on row values)</span>
                </div>
                <div class="yn-toggle">
                  <button
                    type="button"
                    [class.y-active]="field.conditionEnabled"
                    (click)="field.conditionEnabled = true"
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    [class.n-active]="!field.conditionEnabled"
                    (click)="field.conditionEnabled = false"
                  >
                    N
                  </button>
                </div>
              </div>

              <div *ngIf="field.conditionEnabled">
                <div class="border rounded p-2 mb-2 bg-white" *ngFor="let cond of field.conditions; let cIdx = index">
                  <div class="row g-2 align-items-center">
                    <div class="col-md-2" *ngIf="cIdx > 0">
                      <label class="field-label text-primary fw-bold">Logic</label>
                      <select class="form-select form-select-sm fw-bold border-primary" [(ngModel)]="cond.logic" name="fCondLogic{{i}}_{{cIdx}}">
                        <option value="AND">AND (&&)</option>
                        <option value="OR">OR (||)</option>
                      </select>
                    </div>

                    <div [class]="cIdx > 0 ? 'col-md-3' : 'col-md-4'">
                      <label class="field-label">Table Column to Check <span class="text-danger">*</span></label>
                      <select class="form-select form-select-sm" [(ngModel)]="cond.key" name="fCondKey{{i}}_{{cIdx}}">
                        <option [value]="''">-- Select Column --</option>
                        <option *ngFor="let k of getExistingKeysList()" [value]="k">{{ k }}</option>
                      </select>
                    </div>

                    <div class="col-md-3">
                      <label class="field-label">Condition Operator</label>
                      <select class="form-select form-select-sm" [(ngModel)]="cond.operator" name="fCondOp{{i}}_{{cIdx}}">
                        <option value="==">Equals (==)</option>
                        <option value="!=">Not Equals (!=)</option>
                        <option value="in">Is one of (comma-separated)</option>
                        <option value="notIn">Is not one of</option>
                        <option value="contains">Contains / Has</option>
                        <option value="truthy">Is not empty / True</option>
                        <option value="falsy">Is empty / False</option>
                      </select>
                    </div>

                    <div [class]="cIdx > 0 ? 'col-md-3' : 'col-md-4'" *ngIf="cond.operator !== 'truthy' && cond.operator !== 'falsy'">
                      <label class="field-label">Value to Check <span class="text-danger">*</span></label>
                      <div class="input-group input-group-sm">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="e.g. 1,2,3 or Active"
                          [(ngModel)]="cond.value"
                          name="fCondVal{{i}}_{{cIdx}}"
                        />
                        <button
                          type="button"
                          class="btn btn-outline-danger"
                          title="Remove condition rule"
                          *ngIf="field.conditions && field.conditions.length > 1"
                          (click)="removeConditionRule(field, cIdx)"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>

                    <div class="col-md-1 d-flex align-items-end" *ngIf="(cond.operator === 'truthy' || cond.operator === 'falsy') && field.conditions && field.conditions.length > 1">
                      <button
                        type="button"
                        class="btn btn-outline-danger btn-sm"
                        title="Remove condition rule"
                        (click)="removeConditionRule(field, cIdx)"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm py-0 px-2"
                    style="font-size: 11.5px;"
                    (click)="addConditionRule(field)"
                  >
                    <i class="bi bi-plus-circle me-1"></i> Add Another Condition Rule
                  </button>
                  <span class="text-muted small" style="font-size: 11px;">
                    Multiple rules evaluate with selected AND / OR connectors
                  </span>
                </div>

                <div class="col-12 mt-2" *ngIf="field.conditions?.length">
                  <div class="alert alert-info py-1 px-2 m-0 small" style="font-size: 11.5px;">
                    <i class="bi bi-info-circle me-1"></i>
                    <strong>Rule:</strong>
                    <span *ngIf="field.type === 'bitcase'" class="badge bg-primary text-white me-1">Bit Case: Checkboxes Hide on False</span>
                    Show {{ field.type === 'bitcase' ? 'checkboxes' : 'field' }} when:
                    <span *ngFor="let cond of field.conditions; let cIdx = index">
                      <strong class="text-danger mx-1" *ngIf="cIdx > 0">{{ cond.logic || 'AND' }}</strong>
                      <code>row["{{ cond.key || 'column' }}"]</code> {{ cond.operator || '==' }} <code>"{{ cond.value }}"</code>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mt-2">
            <div class="field-group-title">Behavior</div>
            <div class="d-flex gap-4 flex-wrap mt-1">
              <div>
                <label class="field-label">Required</label>
                <div class="yn-toggle">
                  <button
                    type="button"
                    [class.y-active]="field.required"
                    (click)="field.required = true"
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    [class.n-active]="!field.required"
                    (click)="field.required = false"
                  >
                    N
                  </button>
                </div>
              </div>

              <div>
                <label class="field-label">Readonly</label>
                <div class="yn-toggle">
                  <button
                    type="button"
                    [class.y-active]="field.readonly"
                    (click)="field.readonly = true"
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    [class.n-active]="!field.readonly"
                    (click)="field.readonly = false"
                  >
                    N
                  </button>
                </div>
              </div>

              <div>
                <label class="field-label">View (Visible)</label>
                <div class="yn-toggle">
                  <button
                    type="button"
                    [class.y-active]="field.view !== false"
                    (click)="field.view = true"
                  >
                    Y
                  </button>
                  <button
                    type="button"
                    [class.n-active]="field.view === false"
                    (click)="field.view = false"
                  >
                    N
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Role Permissions & Access Control for Form Field -->
          <div class="col-12 mt-2">
            <div class="field-group-title">
              Roles (hide field)
              <span class="info-tip" title="Roles not allowed to see this field in form. Value will still be submitted in payload.">ⓘ</span>
            </div>
            <div class="dropdown w-100" ngbDropdown>
              <button
                class="btn btn-outline-secondary btn-sm dropdown-toggle w-100 d-flex justify-content-between align-items-center text-truncate"
                type="button"
                ngbDropdownToggle
              >
                <span class="text-truncate">
                  {{ field.role?.length ? field.role.length + ' role(s) selected' : 'No roles restricted' }}
                </span>
                <span class="role-caret">&#9660;</span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu p-2 shadow w-100" style="min-width: 260px; max-height: 320px;">
                <div class="px-1 pb-2 mb-1 border-bottom">
                  <input
                    type="text"
                    class="form-control form-control-sm mb-2"
                    placeholder="Search roles..."
                    [(ngModel)]="roleSearchTerm['inner_field_role_' + i]"
                    name="innerFieldRoleSearch{{i}}"
                    (click)="$event.stopPropagation()"
                  />
                  <div class="d-flex justify-content-between">
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 text-decoration-none"
                      (click)="selectAllRolesInList(field, 'role', 'inner_field_role_' + i)"
                    >
                      Select All
                    </button>
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
                      (click)="deselectAllRolesInList(field, 'role', 'inner_field_role_' + i)"
                    >
                      Clear
                    </button>
                  </div>
                </div>
                <div style="max-height: 180px; overflow-y: auto;">
                  <div *ngIf="getFilteredRoles(roleSearchTerm['inner_field_role_' + i]).length === 0" class="text-muted small p-2 text-center">
                    No roles found
                  </div>
                  <div
                    class="dropdown-item-check"
                    *ngFor="let r of getFilteredRoles(roleSearchTerm['inner_field_role_' + i])"
                    (click)="toggleRoleInList(field, 'role', r.type); $event.stopPropagation()"
                  >
                    <input
                      class="form-check-input pointer-events-none"
                      type="checkbox"
                      [checked]="isRoleInList(field.role, r.type)"
                      tabindex="-1"
                    />
                    <span class="dropdown-item-label small">
                      {{ r.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="selected-roles-chips mt-2 d-flex flex-wrap gap-1" *ngIf="field.role?.length">
              <span
                class="badge d-flex align-items-center gap-1 px-2 py-1"
                *ngFor="let roleType of field.role"
              >
                {{ getRoleNameByType(roleType) }}
                <button
                  type="button"
                  class="btn-close btn-close-xs"
                  aria-label="Remove"
                  (click)="removeRoleFromList(field, 'role', roleType)"
                ></button>
              </span>
            </div>
          </div>

          <!-- Dropdown API Configuration -->
          <ng-container *ngIf="field.type === 'dropdownUrl'">
            <div class="col-12 mt-2">
              <div class="field-group-title">Dropdown API Configuration</div>
              <div class="row g-2 mt-1">
                <div class="col-md-3">
                  <label class="field-label">API URL</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="e.g. Maintenance-Location-List"
                    [(ngModel)]="field.apiUrl"
                    name="fApiUrl{{i}}"
                  />
                </div>

                <div class="col-md-3">
                  <label class="field-label">Payload</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder='e.g. {"type": "all"}'
                    [(ngModel)]="field.payloadStr"
                    name="fPayload{{i}}"
                  />
                </div>

                <div class="col-md-2">
                  <label class="field-label">Value Key</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="id"
                    [(ngModel)]="field.optionKey"
                    name="fOptionKey{{i}}"
                  />
                </div>

                <div class="col-md-2">
                  <label class="field-label">Label Key</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="name"
                    [(ngModel)]="field.option_mapping.name"
                    name="fOptionVal{{i}}"
                  />
                </div>

                <div class="col-md-2">
                  <label class="field-label">Match Key</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="e.g. location_id"
                    [(ngModel)]="field.matchKey"
                    name="fMatchKey{{i}}"
                  />
                </div>

                <div class="col-md-12 d-flex justify-content-end mt-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="toggleFieldExtraOption(field)"
                  >
                    {{ field.extraOption ? '✕ Remove Extra Option' : '+ Add Extra Option (ALL)' }}
                  </button>
                </div>
              </div>

              <div class="row g-2 mt-1 p-2 border rounded bg-light" *ngIf="field.extraOption">
                <div class="col-md-6">
                  <label class="field-label">Extra Option Value (e.g. ALL)</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="e.g. ALL"
                    [(ngModel)]="field.extraOption.id"
                    name="fExtraOptId{{i}}"
                  />
                </div>
                <div class="col-md-6">
                  <label class="field-label">Extra Option Label (e.g. All Units)</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="e.g. All Units"
                    [(ngModel)]="field.extraOption.name"
                    name="fExtraOptName{{i}}"
                  />
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Dropdown Static List Configuration -->
          <ng-container *ngIf="field.type === 'dropdownList'">
            <div class="col-12 mt-2">
              <div class="field-group-title">Static Options (ID & Name)</div>
              <div
                class="d-flex gap-2 mb-2 align-items-center"
                *ngFor="let opt of field.options; let j = index"
              >
                <div class="flex-grow-1">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Option ID / Value (e.g. 1)"
                    [(ngModel)]="opt.id"
                    name="fOptId{{i}}_{{j}}"
                  />
                </div>
                <div class="flex-grow-1">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Option Label / Name (e.g. Active)"
                    [(ngModel)]="opt.name"
                    name="fOptName{{i}}_{{j}}"
                  />
                </div>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="removeOption(field, j)"
                  title="Remove option"
                >
                  ✕
                </button>
              </div>

              <button
                type="button"
                class="btn btn-sm btn-outline-secondary mt-1"
                (click)="addOption(field)"
              >
                + Add Option
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex gap-2 mt-2">
    <button
      type="button"
      class="add-column-btn"
      (click)="addFieldTo(fields)"
    >
      + Add Form Field
    </button>
    <button
      type="button"
      class="btn btn-sm btn-outline-success d-flex align-items-center gap-1 px-3"
      style="border-radius: 8px; font-weight: 600;"
      (click)="openHtmlImportModal(fields)"
      title="Import fields from working site HTML dialog snippet"
    >
      <i class="bi bi-filetype-html"></i> Import from HTML
    </button>
  </div>
</ng-template>

<!-- HTML Form Importer Modal -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="showHtmlImportModal" style="background: rgba(15, 23, 42, 0.65); z-index: 1060;">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg" style="border-radius: 12px; overflow: hidden;">
      <div class="modal-header bg-light py-3 px-4 border-bottom">
        <div class="d-flex align-items-center gap-2">
          <div class="bg-success text-white rounded p-1 d-flex align-items-center justify-content-center" style="width: 28px; height: 28px;">
            <i class="bi bi-filetype-html"></i>
          </div>
          <div>
            <h5 class="modal-title m-0 fw-bold" style="font-size: 16px;">Import Form from HTML Snippet</h5>
            <small class="text-muted">Paste working site dialog / form HTML to automatically extract keys, labels, types, and values</small>
          </div>
        </div>
        <button type="button" class="btn-close" (click)="closeHtmlImportModal()"></button>
      </div>

      <div class="modal-body p-4">
        <!-- Paste Area -->
        <div class="mb-3">
          <label class="form-label fw-semibold small d-flex justify-content-between">
            <span>Paste HTML Dialog / Table Form Code:</span>
            <span class="text-muted font-monospace" style="font-size: 11px;">e.g. jQuery UI Dialog, &lt;form&gt;, &lt;table&gt;</span>
          </label>
          <textarea
            class="form-control font-monospace"
            rows="6"
            style="font-size: 12px; background: #f8fafc;"
            [(ngModel)]="htmlImportRawText"
            placeholder="Paste &lt;div class=&quot;ui-dialog...&quot;&gt;... or &lt;form&gt;...&lt;/form&gt; here"
          ></textarea>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span class="text-muted small" style="font-size: 11.5px;">
              <i class="bi bi-magic me-1"></i> Automatically detects field IDs, labels, input types, values, readonly locks, and table column auto-fills.
            </span>
            <button
              type="button"
              class="btn btn-primary btn-sm px-3 d-flex align-items-center gap-1 fw-semibold"
              (click)="parseHtmlFormSnippet()"
            >
              <i class="bi bi-cpu"></i> Parse HTML
            </button>
          </div>
        </div>

        <!-- Parsed Results Preview -->
        <div *ngIf="parsedImportFields.length > 0" class="mt-4 pt-3 border-top">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
              <h6 class="fw-bold mb-0 text-dark">
                <i class="bi bi-check2-circle text-success me-1"></i>
                Detected Fields ({{ parsedImportFields.length }})
              </h6>
              <span class="text-muted small">Review the fields to be imported into your form</span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <button type="button" class="btn btn-link btn-sm p-0 text-decoration-none" (click)="selectAllImportFields(true)">Select All</button>
              <span class="text-muted">|</span>
              <button type="button" class="btn btn-link btn-sm p-0 text-danger text-decoration-none" (click)="selectAllImportFields(false)">Deselect All</button>
            </div>
          </div>

          <!-- Detected Metadata Info -->
          <div class="row g-2 mb-3 p-2 bg-light rounded border" *ngIf="parsedImportTitle || parsedImportApiKey">
            <div class="col-md-6" *ngIf="parsedImportTitle">
              <span class="text-muted small">Detected Dialog Title:</span>
              <div class="fw-bold small text-primary">{{ parsedImportTitle }}</div>
            </div>
            <div class="col-md-6" *ngIf="parsedImportApiKey">
              <span class="text-muted small">Detected Action / API Key:</span>
              <div class="fw-bold small text-success">{{ parsedImportApiKey }}</div>
            </div>
          </div>

          <!-- Fields Table Preview -->
          <div class="table-responsive border rounded" style="max-height: 280px; overflow-y: auto;">
            <table class="table table-sm table-hover align-middle mb-0" style="font-size: 12px;">
              <thead class="table-light sticky-top">
                <tr>
                  <th style="width: 36px;" class="text-center">#</th>
                  <th>Key (ID)</th>
                  <th>Label / Placeholder</th>
                  <th>Type</th>
                  <th>Readonly</th>
                  <th>Fill from Row</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pf of parsedImportFields; let pfi = index" [class.table-light]="!pf.selected">
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="pf.selected" />
                  </td>
                  <td>
                    <span class="badge bg-secondary font-monospace">{{ pf.id }}</span>
                    <span *ngIf="!pf.view" class="badge bg-warning text-dark ms-1" style="font-size: 9px;">HIDDEN</span>
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm py-0" [(ngModel)]="pf.placeholder" style="font-size: 12px;" />
                  </td>
                  <td>
                    <span class="badge bg-light text-dark border">{{ pf.type }}</span>
                  </td>
                  <td>
                    <span *ngIf="pf.readonly" class="badge bg-info text-dark">YES</span>
                    <span *ngIf="!pf.readonly" class="text-muted small">NO</span>
                  </td>
                  <td>
                    <span *ngIf="pf.fillFromKey" class="badge bg-success-subtle text-success border border-success-subtle font-monospace">
                      row["{{ pf.fillFromKey }}"]
                    </span>
                    <span *ngIf="!pf.fillFromKey" class="text-muted small">--</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Import Mode Selection -->
          <div class="d-flex align-items-center gap-3 mt-3 pt-2">
            <span class="fw-semibold small">Import Action:</span>
            <div class="form-check form-check-inline m-0">
              <input class="form-check-input" type="radio" name="htmlImportMode" id="importRep" [value]="true" [(ngModel)]="htmlImportReplace">
              <label class="form-check-label small" for="importRep">Replace current form fields</label>
            </div>
            <div class="form-check form-check-inline m-0">
              <input class="form-check-input" type="radio" name="htmlImportMode" id="importApp" [value]="false" [(ngModel)]="htmlImportReplace">
              <label class="form-check-label small" for="importApp">Append to existing fields</label>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer bg-light py-2 px-4 border-top d-flex justify-content-between">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeHtmlImportModal()">Cancel</button>
        <button
          type="button"
          class="btn btn-success btn-sm px-4 fw-semibold"
          [disabled]="parsedImportFields.length === 0"
          (click)="applyHtmlImport()"
        >
          <i class="bi bi-box-arrow-in-down me-1"></i> Apply Import
        </button>
      </div>
    </div>
  </div>
</div>

<app-knowledge-base></app-knowledge-base>
